module.exports = __webpack_public_path__ + "img/shield-shaded.805b80aa.svg";